// Genre display name mapping for proper casing (following festival families pattern)
export const getGenreDisplayName = (genre: string): string => {
	const genreMap: Record<string, string> = {
		edm: "EDM",
		rock: "Rock",
		pop: "Pop",
		jazz: "Jazz",
		blues: "Blues",
		rap: "Rap",
		hip: "Hip",
		hop: "Hop",
		"hip hop": "Hip Hop",
		country: "Country",
		folk: "Folk",
		classical: "Classical",
		reggae: "Reggae",
		punk: "Punk",
		metal: "Metal",
		alternative: "Alternative",
		indie: "Indie",
		electronic: "Electronic",
		house: "House",
		techno: "Techno",
		trance: "Trance",
		dubstep: "Dubstep",
		drum: "Drum",
		bass: "Bass",
		"drum and bass": "Drum and Bass",
		ambient: "Ambient",
		experimental: "Experimental",
		minimal: "Minimal",
		progressive: "Progressive",
		psychedelic: "Psychedelic",
		disco: "Disco",
		funk: "Funk",
		soul: "Soul",
		rnb: "R&B",
		"r&b": "R&B",
		latin: "Latin",
		reggaeton: "Reggaeton",
		world: "World",
		afrobeat: "Afrobeat",
		gospel: "Gospel",
		idm: "IDM",
		breakbeat: "Breakbeat",
		jungle: "Jungle",
		garage: "Garage",
		grime: "Grime",
		trap: "Trap",
		future: "Future",
		synthwave: "Synthwave",
		vaporwave: "Vaporwave",
		chillwave: "Chillwave",
		darkwave: "Darkwave",
		coldwave: "Coldwave",
		newwave: "New Wave",
		"new wave": "New Wave",
		electro: "Electro",
		ebm: "EBM",
		hardcore: "Hardcore",
		gabber: "Gabber",
		"hands up": "Hands Up",
		eurodance: "Eurodance",
		deep: "Deep",
		hard: "Hard",
		melodic: "Melodic",
		dark: "Dark",
		uplifting: "Uplifting",
		chill: "Chill",
		lounge: "Lounge",
		downtempo: "Downtempo",
		underground: "Underground",
		"lo-fi": "Lo-Fi",
		acoustic: "Acoustic",
		live: "Live",
		retro: "Retro",
		vintage: "Vintage",
		classic: "Classic",
	};

	return (
		genreMap[genre.toLowerCase()] ||
		genre
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ")
	);
};